import React from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay';

// components
import { FormattedMessage } from 'react-intl';
import { ExpandingAreaWithReadMore } from 'dibs-elements/exports/ExpandingArea';

// styles
import styles from './PdpSharedDescription.scss';

// helpers
import get from 'lodash.get';
import classNames from 'classnames';

function getRoleString(role) {
    if (!role) {
        return '';
    }
    const [firstLetter] = role;
    const restOfLetters = role.substring(1);
    return `(${firstLetter.toUpperCase()}${restOfLetters.toLowerCase()})`;
}

export const Title = ({ name, role }) => (
    <FormattedMessage
        id="PdpSharedDescriptionAboutCreator.creatorTitle"
        defaultMessage="About {name} {role}"
        values={{ name, role: getRoleString(role) }}
    />
);
Title.propTypes = {
    name: PropTypes.string,
    role: PropTypes.string,
};
export const Content = ({ contentClass, description }) => {
    return (
        <ExpandingAreaWithReadMore collapsedHeight={72}>
            <span
                className={classNames(styles.creatorContent, contentClass)}
                dangerouslySetInnerHTML={{ __html: description }}
            />
        </ExpandingAreaWithReadMore>
    );
};
Content.propTypes = {
    contentClass: PropTypes.string,
    description: PropTypes.string,
};

function PdpSharedDescriptionAboutCreatorComponent(props) {
    const { headerClass, contentClass, item } = props;
    const { role, name, description } = get(item, 'creatorContent') || {};

    if (!name || !description) {
        return null;
    }

    return (
        <div data-tn="pdp-item-description-about-creator" className={styles.wrapper}>
            <h2 className={classNames(styles.header, headerClass)}>
                <Title name={name} role={role} />
            </h2>
            <Content contentClass={contentClass} description={description} />
        </div>
    );
}

PdpSharedDescriptionAboutCreatorComponent.propTypes = {
    contentClass: PropTypes.string,
    headerClass: PropTypes.string,
    item: PropTypes.object.isRequired,
};

export const PdpSharedDescriptionAboutCreator = createFragmentContainer(
    PdpSharedDescriptionAboutCreatorComponent,
    {
        item: graphql`
            fragment PdpSharedDescriptionAboutCreator_item on Item {
                creatorContent {
                    name
                    description
                    role
                }
            }
        `,
    }
);
